import { Injectable } from '@angular/core';
import {BaseService} from "@core/service/base.service";
import {HttpClient} from '@angular/common/http';
import {catchError, tap} from "rxjs/operators";
import {Observable} from "rxjs/index";

@Injectable({
  providedIn: 'root'
})
export class JyExtendObjectService extends BaseService {
  private url = 'api/biz-table';
  constructor(http: HttpClient) {
    super(http);
  }

  getUrl(): string {
    return this.url;
  }

  againObject(index):Observable<any>{            //重构模板
    const url = `${this.getUrl()}/` + index + '/build';
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`module detail`)),
      catchError(this.handleError<any>(`get module detail`))
    );
  }

  getBizTableDetail(name):Observable<any>{            //根据实体名获取扩展对象详情
    const url = `${this.getUrl()}/` + name+'/activated-field';
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`bizTable detail`)),
      catchError(this.handleError<any>(`get bizTable detail`))
    );
  }
}
